import * as PathNavigation from '@site/components/PathNavigation'

interface Text {
  PRIVACY_TITLE: string
  PRIVACY_TEXT: string
  PRIVACY_TEXT_LINK: string
  PRIVACY_LINK: string
  PRIVACY_BUTTON: string
}

export const CookiesTexts: Text = {
  'PRIVACY_TITLE': 'Privacidade',
  'PRIVACY_TEXT': 'Utilizamos cookies para personalizar sua experiência. Ao continuar, você concorda com este uso.',
  'PRIVACY_TEXT_LINK': 'Saiba mais',
  'PRIVACY_LINK': PathNavigation.privacidadeESeguranca,
  'PRIVACY_BUTTON': 'Entendi',
}


